"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findPriceHistoryByAssetId = exports.findByAssetId = exports.findAll = void 0;
const market_providers_1 = require("./market-providers");
const findAll = async (args) => {
    let result = null;
    // Go through market providers listed above and look for market data for all assets.
    // Once data is found, exit the loop and return result. If no data is found for any
    // provider, throw an error.
    for (let i = 0; i < market_providers_1.MarketProviders.length && !result; i++) {
        try {
            result = await market_providers_1.MarketProviders[i].findAll(args);
        }
        catch (e) {
            console.info(e);
        }
    }
    if (!result)
        throw new Error('Cannot find market service provider for market data.');
    return result;
};
exports.findAll = findAll;
const findByAssetId = async ({ assetId }) => {
    let result = null;
    // Loop through market providers and look for asset market data. Once found, exit loop.
    for (let i = 0; i < market_providers_1.MarketProviders.length && !result; i++) {
        try {
            result = await market_providers_1.MarketProviders[i].findByAssetId({ assetId });
        }
        catch (e) {
            // Swallow error, not every asset will be with every provider.
            continue;
        }
    }
    if (!result)
        return null;
    return result;
};
exports.findByAssetId = findByAssetId;
const findPriceHistoryByAssetId = async ({ assetId, timeframe }) => {
    let result = null;
    // Loop through market providers and look for asset price history data. Once found, exit loop.
    for (let i = 0; i < market_providers_1.MarketProviders.length && !(result === null || result === void 0 ? void 0 : result.length); i++) {
        try {
            result = await market_providers_1.MarketProviders[i].findPriceHistoryByAssetId({ assetId, timeframe });
        }
        catch (e) {
            // Swallow error, not every asset will be with every provider.
            continue;
        }
    }
    if (!result)
        return [];
    return result;
};
exports.findPriceHistoryByAssetId = findPriceHistoryByAssetId;
